<template>
  <base-dropdown>
    <div
      slot="title"
      class="dropdown dropdown-button d-flex align-items-center"
    >
      <font-awesome-icon
        :icon="['fal', 'ellipsis-h']"
        class="options_selection"
      />
    </div>
    <div>
      <!-- RENAME -->
      <not-allowed-tooltip
        :user-permissions="userPermissions"
        permission-key="canUpdateContent"
      >
        <template v-slot:main-content="{ hasPermissions }">
          <div class="dropdown-item">
            <h5
              class="text-overflow m-0"
              @click="hasPermissions ? $emit('edit-label') : ''"
            >
              <font-awesome-icon
                :icon="['fad', 'edit']"
                class="edit-node-icon"
              />
              <small class="ml-2">{{ $t('knowledge.actions.rename') }}</small>
            </h5>
          </div>
        </template>
      </not-allowed-tooltip>

      <!-- CLONE -->
      <not-allowed-tooltip
        v-if="!focusKnowledgeIsMultilinguale"
        :user-permissions="userPermissions"
        permission-key="canCreateContent"
      >
        <template v-slot:main-content="{ hasPermissions }">
          <div class="dropdown-item">
            <h5
              class="text-overflow m-0"
              @click="hasPermissions ? $emit('clone-kb') : ''"
            >
              <font-awesome-icon
                :icon="['fad', 'copy']"
                class="edit-node-icon"
              />
              <small class="ml-2">{{
                $t('knowledge.actions.clone-in-other-kb')
              }}</small>
            </h5>
          </div>
        </template>
      </not-allowed-tooltip>

      <!-- DUPLICATE IN SAME LOCATION -->
      <not-allowed-tooltip
        :user-permissions="userPermissions"
        permission-key="canCreateContent"
      >
        <template v-slot:main-content="{ hasPermissions }">
          <div
            class="dropdown-item"
            @click="hasPermissions ? $emit('duplicate-in-same-location') : ''"
          >
            <h5 class="text-overflow m-0">
              <font-awesome-icon
                :icon="['fad', 'object-group']"
                class="option-icon"
              />
              <small class="ml-2">{{
                $t('knowledge.actions.duplicate-in-same-location')
              }}</small>
            </h5>
          </div>
        </template>
      </not-allowed-tooltip>

      <!-- UPDATE VERIFICATION -->
      <div class="dropdown-item" v-if="type && !isOutdated">
        <h5
          class="text-overflow m-0"
          @click="$emit('update-content-verification', true)"
        >
          <font-awesome-icon
            :icon="['fad', 'times-circle']"
            class="edit-node-icon"
          />
          <small class="ml-2">{{ $t('knowledge.actions.outdate') }}</small>
        </h5>
      </div>

      <!-- DELETE / ARCHIVE -->
      <div class="dropdown-divider"></div>
      <not-allowed-tooltip
        :user-permissions="userPermissions"
        permission-key="canDeleteContent"
      >
        <template v-slot:main-content="{ hasPermissions }">
          <div class="dropdown-item">
            <h5
              class="text-overflow m-0"
              @click="hasPermissions ? $emit('delete-node') : ''"
            >
              <font-awesome-icon
                :icon="['fad', 'trash']"
                class="edit-node-icon text-red"
              />
              <small v-if="type" class="ml-2">{{
                $t('knowledge.actions.archive')
              }}</small>
              <small v-else class="ml-2">{{
                $t('knowledge.actions.delete')
              }}</small>
            </h5>
          </div>
        </template>
      </not-allowed-tooltip>
    </div>
  </base-dropdown>
</template>
<script>
import { mapGetters } from 'vuex';
import NotAllowedTooltip from '@/components/Commons/NotAllowedTooltip';
export default {
  name: 'edit-node-options',
  components: {
    NotAllowedTooltip,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    isOutdated: {
      type: Boolean,
      default: false,
    },
    userPermissions: {
      type: Object,
    },
  },
  computed: {
    isFolder() {
      return !this.type;
    },
    ...mapGetters('knowledgeModule', ['focusKnowledgeIsMultilinguale']),
  },
};
</script>
<style lang="scss" scoped>
.dropdown {
  padding: 0px;
}

.dropdown-button {
  border-width: 0px;
  box-shadow: none;
  margin: auto;
}

.pointer {
  cursor: pointer;
}

.edit-node-icon {
  color: #adb5bd;
  max-width: 14px;
}

.options_selection {
  width: 16px;
  color: #adb5bd;
  cursor: pointer;
}

.options_selection:hover {
  color: $blue-mayday;
}
</style>
